import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './App.css';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';

import JournalistParser from './JournalistParser.jsx';
import ProgressiveParser from './ProgressiveParser.jsx';
import Title from "./Title";
import React, { useState } from "react";
import {trustedPublications} from "./trusted-publications";

function App() {
    const [type, setType] = useState(null);

    function setJournalists() {
        setType("journalists");
    }

    function setProgressives() {
        setType("progressives");
    }

    function backToMenu() {
        setType(null);
    }

  return (
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
                {type === null ?
                    (
                        <>
                        <Title>Which list are you interested in?</Title>
                        <div>
                            <Button variant="contained" onClick={e => {
                                setJournalists();
                            }}>Journalists</Button> <Button variant="contained" onClick={e => {
                            setProgressives();
                        }}>US Progressives</Button>
                        </div>
                        </>
                    ) : null
                }
                {type === 'journalists' ?
                    (
                        <>
                            <Grid container spacing={2}>
                                <Grid item xs={6} md={8}>
                                    <Title>Journalists on Mastodon</Title>
                                </Grid>
                                <Grid item xs={6} md={4} className="text-right"><Button variant="contained" onClick={e => {
                                    backToMenu();
                                }}>Back</Button>
                                </Grid>
                            </Grid>
                            <JournalistParser />
                        </>
                    ) : null
                }
                {type === 'progressives' ?
                    (
                        <>
                            <Grid container spacing={2}>
                                <Grid item xs={6} md={8}>
                                    <Title>US Progressives on Mastodon</Title>
                                </Grid>
                                <Grid item xs={6} md={4} className="text-right"><Button variant="contained" onClick={e => {
                                    backToMenu();
                                }}>Back</Button>
                                </Grid>
                            </Grid>
                            <ProgressiveParser />
                        </>
                    ) : null
                }
            </Grid>
          </Grid>
        </Container>
    </Box>
  );
}

export default App;
